module.exports = __webpack_public_path__ + "img/cutting-edge-en-3.72f9498.jpg";